import { gql } from "graphql-request";

/**
 * 단발성 presigned URL 발급 — mutation 으로 두어 캐싱 회피 + audit log 친화.
 * 서버 TTL 10분.
 */
export const ADMIN_CONTEST_SUBMISSION_DOWNLOAD_URL = gql`
  mutation AdminContestSubmissionDownloadUrl($submissionId: String!) {
    adminContestSubmissionDownloadUrl(submissionId: $submissionId)
  }
`;

/**
 * 원고 zip 일괄 다운로드 준비 — 조건에 맞는 건수/용량 확인 + 단기 토큰 발급.
 * 실제 파일은 이 토큰을 붙인 REST GET 으로 받는다 (buildManuscriptArchiveUrl).
 */
export const ADMIN_CONTEST_MANUSCRIPT_ARCHIVE = gql`
  mutation AdminContestManuscriptArchive(
    $input: AdminContestManuscriptArchiveInputDto!
  ) {
    adminContestManuscriptArchive(input: $input) {
      token
      count
      totalBytes
    }
  }
`;

/** 1차 심사 단건 판정 — 갱신된 screening 만 받아 캐시 무효화로 반영. */
export const ADMIN_CONTEST_SET_SCREENING = gql`
  mutation AdminContestSetScreening($input: AdminContestSetScreeningInputDto!) {
    adminContestSetScreening(input: $input) {
      _id
      screening {
        result
        memo
        checklist {
          key
          value
        }
        reviewerEmail
        reviewedAt
      }
    }
  }
`;

export const ADMIN_CONTEST_BULK_SET_SCREENING = gql`
  mutation AdminContestBulkSetScreening(
    $input: AdminContestBulkSetScreeningInputDto!
  ) {
    adminContestBulkSetScreening(input: $input) {
      updatedCount
      skippedIds
    }
  }
`;

/** 글자수 재계산 — submissionId 없으면 누락분 전체 백필. 반환값 = enqueue 수. */
export const ADMIN_CONTEST_RECOUNT_CHAR_COUNT = gql`
  mutation AdminContestRecountCharCount($submissionId: String) {
    adminContestRecountCharCount(submissionId: $submissionId)
  }
`;

/**
 * 원고 미리보기 발급 — 다운로드 URL 과 같은 이유로 mutation
 * (단발성 presigned URL + 서버 감사로그 + HTTP 캐싱 회피).
 */
export const ADMIN_CONTEST_SUBMISSION_PREVIEW = gql`
  mutation AdminContestSubmissionPreview($submissionId: String!) {
    adminContestSubmissionPreview(submissionId: $submissionId) {
      kind
      url
      html
      errorCode
    }
  }
`;

/** 필드별 심사 메모 즉시 저장 — 빈 note 는 삭제. 갱신된 reviewNotes 반환. */
export const ADMIN_CONTEST_SET_FIELD_NOTE = gql`
  mutation AdminContestSetFieldNote($input: AdminContestSetFieldNoteInputDto!) {
    adminContestSetFieldNote(input: $input) {
      _id
      reviewNotes {
        field
        note
        updatedBy
        updatedAt
      }
    }
  }
`;
